namespace $.$$ {

	$mol_style_define( $shm_tests_scenario, {

		flex: {
			basis: '24rem',
		},

		Body_content: {
			flex: {
				direction: 'column',
			},
			gap: $mol_gap.block,
			padding: $mol_gap.block,
		},

		Run_tools: {
			flex: {
				wrap: 'wrap',
			},
			gap: $mol_gap.text,
		},

		Version: {
			flex: {
				grow: 1,
			},
		},

		Steps: {
			width: '100%',
		},

		Steps_block: {
			flex: {
				direction: 'column',
			},
			gap: 0,
			width: '100%',
		},

		Steps_label: {
			padding: {
				left: $mol_gap.block,
			},
		},

		Step: {
			flex: {
				direction: 'column',
			},
			align: {
				items: 'stretch',
			},
			justify: {
				content: 'flex-start',
			},
			gap: $mol_gap.text,
			padding: $mol_gap.block,
			'[shm_hitalama_tests_step_current]': {
				true: {
					color: $mol_theme.current,
				},
			},
		},

	} )

}
